var map = {
	"./3-CN-old.png": "BGi9",
	"./3-CN.png": "sdBn",
	"./3-EN-old.png": "MLwB",
	"./3-EN.png": "wkcd"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "OnRi";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home ^\.\/3\-.*\.png$
// module id = OnRi
// module chunks = 1